import { createSelector } from 'reselect';
import { AppState } from 'state/state.model';

const selectSmartQuoteWorkspace = (state: AppState) => state.workspaces.smartQuote;

export const getTabPrompts = createSelector(
  [selectSmartQuoteWorkspace, (_state: AppState, tabId: string) => tabId],
  (smartQuoteWorkspace, tabId) => smartQuoteWorkspace[tabId]?.prompts ?? [],
);

export const getPrompt = createSelector(
  [getTabPrompts, (_state: AppState, _tabId: string, promptId: string) => promptId],
  (tabPrompts, promptId) => tabPrompts[promptId] ?? {},
);

export const getTabPromptsIds = createSelector([getTabPrompts], tabPrompts => Object.keys(tabPrompts));

export const getTabQuotesId = createSelector([getTabPrompts], tabPrompts => {
  const promptsResults = Object.values(tabPrompts).map(prompt => prompt.results);
  const quoteIds = promptsResults.flatMap(results => Object.values(results).map(result => result.rfqId));
  return quoteIds;
});

export const getAllPromptResults = createSelector([selectSmartQuoteWorkspace], smartQuoteWorkspace => {
  const allPromptResults = Object.values(smartQuoteWorkspace ?? {})
    .flatMap(workspace => Object.values(workspace.prompts ?? {}))
    .flatMap(prompt => Object.values(prompt.results ?? {}))
    .flat();
  return allPromptResults;
});

export const getAiGeneratedEntries: (state: AppState) => Record<string, string[] | undefined> = createSelector(
  [getAllPromptResults],
  promptsResults => {
    return Object.fromEntries(promptsResults.map(result => [result.promptId, result.aiGeneratedFields ?? []]));
  },
);
